(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[12434],{

/***/ 12434:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ ProductiveTools; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./src/styles/variables/contentintelligenceVariables.module.scss
var contentintelligenceVariables_module = __webpack_require__(21076);
var contentintelligenceVariables_module_default = /*#__PURE__*/__webpack_require__.n(contentintelligenceVariables_module);
// EXTERNAL MODULE: ./src/components/contentintelligence/productiveTools/styles.module.scss
var styles_module = __webpack_require__(86310);
var styles_module_default = /*#__PURE__*/__webpack_require__.n(styles_module);
;// CONCATENATED MODULE: ./src/components/contentintelligence/svgs/share.tsx


function Share() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "30",
        height: "30",
        fill: "none",
        viewBox: "0 0 30 30",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("mask", {
                id: "mask0_340_4178",
                style: {
                    maskType: "alpha"
                },
                width: "30",
                height: "30",
                x: "0",
                y: "0",
                maskUnits: "userSpaceOnUse",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    fill: "#D9D9D9",
                    d: "M0 0H30V30H0z"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("g", {
                mask: "url(#mask0_340_4178)",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    fill: "#DF8D46",
                    d: "M22.245 20.092a4.26 4.26 0 00-2.762 1.01l-7.84-4.306c.208-.505.327-1.07.327-1.634a4.22 4.22 0 00-.327-1.633l8.137-4.544a4.313 4.313 0 002.436.772 4.278 4.278 0 000-8.553c-2.347 0-4.277 1.93-4.277 4.277 0 .802.208 1.514.594 2.168l-7.9 4.395a4.285 4.285 0 00-2.94-1.158 4.277 4.277 0 000 8.553 4.34 4.34 0 002.94-1.159l7.752 4.277a4.277 4.277 0 003.86 6.118c2.346 0 4.277-1.93 4.277-4.277 0-2.346-1.93-4.306-4.277-4.306z"
                })
            })
        ]
    });
}
/* harmony default export */ var share = (Share);

;// CONCATENATED MODULE: ./src/components/contentintelligence/svgs/microsoft.tsx


function Microsoft() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "30",
        height: "30",
        fill: "none",
        viewBox: "0 0 30 30",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("mask", {
                id: "mask0_340_4184",
                style: {
                    maskType: "alpha"
                },
                width: "30",
                height: "30",
                x: "0",
                y: "0",
                maskUnits: "userSpaceOnUse",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    fill: "#D9D9D9",
                    d: "M0 0H30V30H0z"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("g", {
                fill: "#DF8D46",
                mask: "url(#mask0_340_4184)",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    d: "M2 2h12.046v12.046H2V2zM15.953 2H28v12.046H15.953V2zM2 15.954h12.046V28H2V15.954zM15.953 15.954H28V28H15.953V15.954z"
                })
            })
        ]
    });
}
/* harmony default export */ var microsoft = (Microsoft);

;// CONCATENATED MODULE: ./src/components/contentintelligence/svgs/recordsManagement.tsx


function RecordsManagement() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "30",
        height: "30",
        fill: "none",
        viewBox: "0 0 30 30",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("mask", {
                id: "mask0_343_4237",
                style: {
                    maskType: "alpha"
                },
                width: "30",
                height: "30",
                x: "0",
                y: "0",
                maskUnits: "userSpaceOnUse",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    fill: "#D9D9D9",
                    d: "M0 0H30V30H0z"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("g", {
                fill: "#DF8D46",
                mask: "url(#mask0_343_4237)",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M21.116 23.308v3.78l.037-.036 4.68-4.674c.356-.351.62-.784.77-1.26h-3.297a2.187 2.187 0 00-2.19 2.19z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M26.774 6.435A4.438 4.438 0 0022.34 2H7.657a4.438 4.438 0 00-4.435 4.435v17.13A4.438 4.438 0 007.657 28h11.22c.085 0 .17-.006.25-.012v-4.68a4.18 4.18 0 014.179-4.179h3.468V6.435zm-10.552 13H8.88a.765.765 0 110-1.53h7.342a.764.764 0 110 1.53zm4.894-4.894H8.88a.765.765 0 010-1.53h12.236a.765.765 0 010 1.53zm0-4.894H8.88a.765.765 0 010-1.53h12.236a.765.765 0 010 1.53z"
                    })
                ]
            })
        ]
    });
}
/* harmony default export */ var recordsManagement = (RecordsManagement);

;// CONCATENATED MODULE: ./src/components/contentintelligence/svgs/roboticAutomation.tsx


function RoboticAutomation() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "30",
        height: "30",
        fill: "none",
        viewBox: "0 0 30 30",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("mask", {
                id: "mask0_340_4195",
                style: {
                    maskType: "alpha"
                },
                width: "30",
                height: "30",
                x: "0",
                y: "0",
                maskUnits: "userSpaceOnUse",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    fill: "#D9D9D9",
                    d: "M0 0H30V30H0z"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("g", {
                mask: "url(#mask0_340_4195)",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    fill: "#DF8D46",
                    d: "M28.346 13.397h-2.113V8.606a.895.895 0 00-.893-.893h-8.659V3.577c0-.863-.684-1.577-1.577-1.577-.862 0-1.577.714-1.577 1.577v4.136H4.868a.895.895 0 00-.892.893v4.79H1.893A.895.895 0 001 14.29v6.577c0 .505.387.892.893.892h2.083v4.79c0 .477.386.894.892.894H25.37a.895.895 0 00.893-.893v-4.761h2.113a.895.895 0 00.893-.893v-6.606c-.03-.476-.447-.893-.923-.893zM7.963 14.438c0-1.369 1.1-2.47 2.47-2.47a2.464 2.464 0 012.47 2.47c0 1.369-1.101 2.47-2.47 2.47-1.37-.03-2.47-1.101-2.47-2.47zm11.992 8.302a.895.895 0 01-.893.893h-7.945a.915.915 0 01-.893-.893v-.982c0-.476.417-.893.893-.893h7.945c.476 0 .893.417.893.893v.982zm-.179-5.862c-1.369 0-2.47-1.1-2.47-2.47 0-1.369 1.101-2.47 2.47-2.47 1.369 0 2.47 1.101 2.47 2.47a2.445 2.445 0 01-2.47 2.47z"
                })
            })
        ]
    });
}
/* harmony default export */ var roboticAutomation = (RoboticAutomation);

;// CONCATENATED MODULE: ./src/components/contentintelligence/svgs/smartInvoice.tsx


function SmartInvoices() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "30",
        height: "30",
        fill: "none",
        viewBox: "0 0 30 30",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("mask", {
                id: "mask0_340_4203",
                style: {
                    maskType: "alpha"
                },
                width: "30",
                height: "30",
                x: "0",
                y: "0",
                maskUnits: "userSpaceOnUse",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    fill: "#D9D9D9",
                    d: "M0 0H30V30H0z"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("g", {
                mask: "url(#mask0_340_4203)",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    fill: "#DF8D46",
                    fillRule: "evenodd",
                    d: "M19.849 2c.417 0 .817.171 1.111.476l4.58 4.735c.294.305.46.719.46 1.15v19.097a.533.533 0 01-.524.542H4.524A.533.533 0 014 27.458V2.542C4 2.243 4.234 2 4.524 2h15.325zM9.762 18.25c.29 0 .524.243.524.542v2.166c0 .3-.235.542-.524.542H7.666a.533.533 0 01-.523-.542v-2.166c0-.3.234-.542.523-.542h2.096zm3.143-4.875c.289 0 .524.243.524.542v2.166c0 .3-.235.542-.524.542H7.666a.533.533 0 01-.523-.542v-2.166c0-.3.234-.542.523-.542h5.239zM16.047 8.5c.29 0 .524.243.524.542v2.167c0 .299-.234.541-.524.541H7.666a.533.533 0 01-.524-.541V9.042c0-.3.235-.542.524-.542h8.381zm3.013 16.25a.266.266 0 01-.261-.25V23.223a4.282 4.282 0 01-.746-.2 4.63 4.63 0 01-.712-.323 4.733 4.733 0 01-.52-.349l-.064-.05a3.81 3.81 0 01-.248-.209l-.013-.013a1.864 1.864 0 01-.123-.13c-.08-.102-.084-.201-.014-.298l.722-.98c.033-.047.087-.076.162-.086.07-.01.126.012.168.065l.014.015c.53.479 1.097.78 1.706.907.173.038.346.058.519.058.379 0 .712-.105 1-.312.288-.208.432-.503.432-.886a.756.756 0 00-.106-.384 1.355 1.355 0 00-.235-.305 1.916 1.916 0 00-.41-.272l-.146-.076a7.373 7.373 0 00-.317-.156l-.081-.036a18.075 18.075 0 00-.48-.2l-.488-.204a10.916 10.916 0 01-.288-.128l-.088-.041a4.995 4.995 0 01-.439-.225 7.172 7.172 0 01-.396-.258 2.503 2.503 0 01-.376-.308 4.474 4.474 0 01-.305-.355 1.787 1.787 0 01-.25-.421 2.982 2.982 0 01-.146-.483 2.604 2.604 0 01-.06-.565c0-.668.23-1.253.688-1.756.427-.468.973-.781 1.64-.94v-1.299c0-.15.116-.27.261-.27h1.06c.066 0 .12.02.162.064l.008.01.008.01a.274.274 0 01.072.186v1.241l.063.008a4.401 4.401 0 011.297.4c.157.079.306.17.446.271l.084.061c.085.063.145.11.18.14l.01.01c.042.038.077.072.105.1.075.082.09.167.046.257l-.58 1.079c-.037.072-.09.11-.16.116a.218.218 0 01-.19-.051l-.014-.014a2.093 2.093 0 00-.088-.073l-.033-.026a4.861 4.861 0 00-.24-.166 3.049 3.049 0 00-.933-.42 2.263 2.263 0 00-.6-.084c-.445 0-.808.103-1.089.312-.28.207-.42.476-.42.805a.82.82 0 00.267.65c.097.093.19.173.276.238.08.06.196.128.35.204l.18.086c.085.04.16.075.226.104l.111.048.396.16.29.114c.132.053.24.097.325.133l.063.028c.123.054.28.13.47.226.225.113.401.216.53.308.128.092.273.213.435.363.161.15.285.303.372.46.086.158.16.343.22.556.061.212.092.44.092.681 0 .74-.233 1.378-.698 1.912-.46.528-1.057.857-1.789.986v1.235a.277.277 0 01-.058.17l-.014.017a.215.215 0 01-.178.084h-1.06z",
                    clipRule: "evenodd"
                })
            })
        ]
    });
}
/* harmony default export */ var smartInvoice = (SmartInvoices);

;// CONCATENATED MODULE: ./src/components/contentintelligence/svgs/electronicForms.tsx


function ElectronicForms() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "30",
        height: "30",
        fill: "none",
        viewBox: "0 0 30 30",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("mask", {
                id: "mask0_340_4207",
                style: {
                    maskType: "alpha"
                },
                width: "30",
                height: "30",
                x: "0",
                y: "0",
                maskUnits: "userSpaceOnUse",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    fill: "#D9D9D9",
                    d: "M0 0H30V30H0z"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("g", {
                fill: "#DF8D46",
                fillRule: "evenodd",
                clipRule: "evenodd",
                mask: "url(#mask0_340_4207)",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M17.871 6.333a.875.875 0 00-.883-.867h-3.975a.875.875 0 00-.883.867v17.333c0 .479.395.867.883.867h3.975a.875.875 0 00.883-.867V6.333zm-3.975.867v15.6h2.209V7.2h-2.209z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M26.705 5.467C26.705 3.552 25.123 2 23.17 2h-3.533c-1.951 0-3.533 1.552-3.533 3.467v19.066c0 1.915 1.582 3.467 3.533 3.467h3.533c1.952 0 3.534-1.552 3.534-3.467V5.467zm-5.3 17.224c.487 0 .883.389.883.867a.876.876 0 01-.883.867.875.875 0 01-.884-.867c0-.478.396-.866.884-.866zm0-3.033c.487 0 .883.389.883.867a.875.875 0 01-.883.867.875.875 0 01-.884-.867c0-.478.396-.867.884-.867zm0-3.033c.487 0 .883.388.883.866a.875.875 0 01-.883.867.875.875 0 01-.884-.867c0-.478.396-.866.884-.866zM20.52 6.333v8.125c0 .479.396.867.884.867a.876.876 0 00.883-.867V6.333a.875.875 0 00-.883-.866.875.875 0 00-.884.866zM13.896 5.467C13.896 3.552 12.314 2 10.363 2H6.829C4.878 2 3.296 3.552 3.296 5.467v19.066C3.296 26.448 4.878 28 6.829 28h3.534c1.95 0 3.533-1.552 3.533-3.467V5.467zm-5.3 17.224c.488 0 .883.389.883.867a.875.875 0 01-.883.867.875.875 0 01-.883-.867c0-.478.395-.866.883-.866zm0-3.033c.488 0 .883.389.883.867a.875.875 0 01-.883.867.875.875 0 01-.883-.867c0-.478.395-.867.883-.867zm0-3.033c.488 0 .883.388.883.866a.875.875 0 01-.883.867.875.875 0 01-.883-.867c0-.478.395-.866.883-.866zM7.713 6.333v8.125c0 .479.395.867.883.867a.875.875 0 00.883-.867V6.333a.875.875 0 00-.883-.866.875.875 0 00-.883.866z"
                    })
                ]
            })
        ]
    });
}
/* harmony default export */ var electronicForms = (ElectronicForms);

;// CONCATENATED MODULE: ./src/components/contentintelligence/svgs/bars.tsx


function Bars() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "30",
        height: "30",
        fill: "none",
        viewBox: "0 0 30 30",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("mask", {
                id: "mask0_340_4215",
                style: {
                    maskType: "alpha"
                },
                width: "30",
                height: "30",
                x: "0",
                y: "0",
                maskUnits: "userSpaceOnUse",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    fill: "#D9D9D9",
                    d: "M0 0H30V30H0z"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("g", {
                fill: "#DF8D46",
                mask: "url(#mask0_340_4215)",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    d: "M4.738 18.032a3.625 3.625 0 00-3.621 3.621v2.459a3.62 3.62 0 107.238 0v-2.459a3.623 3.623 0 00-3.617-3.62zM15 10.84a3.625 3.625 0 00-3.621 3.62v9.666a3.62 3.62 0 107.238 0V14.46a3.624 3.624 0 00-3.618-3.621zM25.262 2a3.623 3.623 0 00-3.618 3.617v18.509a3.62 3.62 0 107.238 0V5.617A3.623 3.623 0 0025.262 2z"
                })
            })
        ]
    });
}
/* harmony default export */ var bars = (Bars);

;// CONCATENATED MODULE: ./src/components/contentintelligence/productiveTools/index.tsx











function ProductiveTools() {
    const list = [
        {
            title: "Direct Share",
            description: "Easily and securely share documents outside of your organization and support governance with a tool that provides the ability to email documents with password-protected links and automatic expiration dates.",
            icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(share, {})
        },
        {
            title: "Microsoft 365 Integration",
            description: "Minimize context-switching and streamline workflows by creating, editing, routing and archiving your Microsoft 365 documents in Laserfiche.",
            icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(microsoft, {})
        },
        {
            title: "Records Management",
            description: "Get unparalleled 360-degree view of records in a records management platform guided by DoD 5015.2 principles, to help strengthen compliance across all content and processes.",
            icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(recordsManagement, {})
        },
        {
            title: "Robotic Process Automation",
            description: "Utilize intuitive technology that compromises of bots and programs that can perform repetitive tasks right from a user interface. RPA is fast to deploy, easy to update, and is a powerful catalyst for system integrations.",
            icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(roboticAutomation, {})
        },
        {
            title: "Smart Invoice Capture",
            description: "Boost your accounts payable process turnaround time by leveraging a machine learning-driven intelligent capture tool, adept at effortlessly extracting data from invoices in any format.",
            icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(smartInvoice, {})
        },
        {
            title: "Electronic Forms",
            description: "Create digital-first experiences with web-based forms that make it easy to capture information from clients, constituents or students — then kickstart an automated approvals or review process — with low coding required.",
            icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(electronicForms, {})
        },
        {
            title: "Reporting and Analytics",
            description: "Make more informed decisions with data-driven insights when you discover data trends with custom reporting tools and built-in analytics charts.",
            icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(bars, {})
        }, 
    ];
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
        className: `${(styles_module_default()).container} flex flex-col my-20`,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                style: {
                    color: (contentintelligenceVariables_module_default()).orange
                },
                className: "text-center font-bold text-xl lg:text-4xl mt-20",
                children: "Enhance Efficiency and Productivity with an Expanded Toolkit"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                className: "text-center mb-16 md:mb-24 text-base md:text-lg",
                children: "Accelerate business progress smoothly and swiftly with these empowering tools."
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "grid grid-cols-1 gap-16 lg:grid-cols-2 mb-20",
                children: list.map((item, index)=>/*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "flex flex-col items-start gap-4 md:gap-8",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "flex items-center gap-4",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        children: item.icon
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                        className: "text-lg md:text-2xl",
                                        children: item.title
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                className: "text-sm md:text-base",
                                children: item.description
                            })
                        ]
                    }, index))
            })
        ]
    });
}


/***/ }),

/***/ 86310:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"primaryColor":"#16556d","lightPrimaryColor":"#dff5f9","whyUsItemTitle":"#005670","offerCallNumber":"#006336","slogan":"#018484","progressColor":"#1c75bc","linkColorDefault":"#018484","buttonBgColorDefault":"#01847f","whyUsBackgroundColor":"#005c58","whyUsColor":"#fff","melon":"#fe895c","darkSeaGreen":"#0e7d3f","marigold":"#ffcb03","fadedRed":"#cd2f32","dodgerBlue":"#4f85ff","pinkishGrey":"#bfbfbf","sea":"#329eaa","softBlue":"#6b67e9","slightlyBlack":"#161616","tealGreen":"#83b855","greyish":"#b3b3b3","paleGrey":"#f8f9fa","navy":"#011d41","pagePaddingX":"1rem","autumnGlory":"#3ea636","blackLead":"#464c4d","primary":"#b91c45","shiningSilver":"#c8c8c8","bleachedSilk":"#f3f2f2","blackBeauty":"#28252b","battleshipGrey":"#6d7577","winterSolstice":"#47525d","puritanGrey":"#a8aeaf","nero":"#242626","direWolf":"#272828","placeboBlue":"#ebf4fd","chiGong":"#ff1919","mississippiRiver":"#386189","spiroDiscoBall":"#0ac5ff","linkColor":"#565656","gray":"#eaeaea","grayBg":"#fafafa","graydark":"#b3b3b3","grayLight":"#ececec","orange":"#faa931","orangeDark":"#ff700e","orangeLight":"#f1c19c","orangePopup":"#f7951e","Blue":"#5dbbfe","blueDark":"#1b4874","green":"#0a6938","red":"#f85650","redLight":"#fff5f3","cyan":"#37c8e3","blueAster":"#266199","assault":"#184070","lucea":"#79b4e2","distantHorizon":"#f4f9fa","yellow":"#fff9e7","lynxScreenBlue":"#27aae1","singingBlue":"#0375a3","citrusSplash":"#ffc600","youngNight":"#232323","offerBorderColor":"#e4e7eb","defaultButtonColor":"#00b2b8","defaultProgressColor":"#838282","poseidon":"#143a56","vitamin":"#f90","queenOfTheNight":"#275376","trolleyGrey":"#818181","shadowMountain":"#585858","lcPrimary":"#00203f","lcSecondary":"#fdfdfd","lcLightPrimary":"#bf0a2f","lcHover":"#eef7ff","lcLink":"#ff9a03","lcButton":"#bf0a2f","lcProgress":"#9e9d9e","whyUsTitle":"#2e2e2e","whyUsItemBrief":"#747474","headerPhoneColor":"#dd6453","headerCallCenter":"#129188","goGoGreen":"#008a7b","bankVault":"#747474","secondary":"#444b53","progress":"#e489a2","hover":"#b31c1a","blue":"#0d4085","pink":"#f59aac","hoverBg":"#fef8fb","greyLight":"#f3f3f3","darkGreen":"#00a259","greenButton":"#00a259","purple":"#51378e","orangeHover":"#f1dfd0","grey":"#777","darkRed":"#ae332f","stickBtnBgColor":"#f89a1c","stickBtnBorderColor":"#f89a1c","blueLight":"#e9f9ff","carnival":"#ff9800","nickel":"#2f6177","footerColor":"#2f6177","button":"#fff2f1","darkBlue":"#222e59","lightGreen":"#d3e0c9","purpleLight":"#f6f1ff","purpleDark":"#674998","progressBarColor":"#b0b0b0","sloganColor":"#515151","phoneNumberColor":"#0d7166","popupMainColor":"#4d7ea6","stickTitleColor":"#000","stickBtnTxtColor":"#fff","progressbar":"#9a9a9a","mainColor":"#0071ac","whyUs":"#316767","secondaryColor":"#f2f4ea","tepezzaGrey":"#7d7d7d","paragraphColor":"#232323","iconColor":"#e05d26","whyUsBriefColor":"#747474","gorseYellowOrange":"#ff9800","denimBlue":"#2f6177","container":"styles_container__IIaaV"};

/***/ })

}]);